export const ORDER_STATUS = [
    {
        name: 'Tất cả',
        value: '',
    },
    {
        name: 'Chờ xử lý',
        value: 'pending',
    },
    {
        name: 'Đang xử lý',
        value: 'processing',
    },
    {
        name: 'Đợi duyệt',
        value: 'review',
    },
    {
        name: 'Đã xong một phần',
        value: 'done',
    },
    {
        name: 'Đã xong',
        value: 'fully-done',
    },
    {
        name: 'Tạm dừng',
        value: 'on-hold',
    },
    {
        name: 'Tạo lại',
        value: 'retry',
    },
    {
        name: 'Lỗi',
        value: 'error',
    },
    {
        name: 'Đã hủy',
        value: 'cancelled',
    },
]

export const ORDER_PRINTED = [
    {
        name: 'Tất cả',
        value: '',
    },
    {
        name: 'Chưa in',
        value: 'unprinted',
    },
    {
        name: 'Đã đẩy',
        value: 'pushed',
    },
    {
        name: 'Đã in',
        value: 'printed',
    },
    {
        name: 'Đã cắt',
        value: 'cut',
    },
    {
        name: 'Đã khắc',
        value: 'engraved',
    },
    {
        name: 'Đã hoàn thiện',
        value: 'improved',
    },
    // {
    //     name: 'Đã ép',
    //     value: 'transferred',
    // },
    // {
    //     name: 'QC sau ép',
    //     value: 'confirmed',
    // },
    // {
    //     name: 'Đang may',
    //     value: 'sewing',
    // },
    {
        name: 'Hoàn thành',
        value: 'completed',
    },
    {
        name: 'Đã ship',
        value: 'shipped',
    },
    {
        name: 'Hủy ship',
        value: 'cancel-ship',
    }
]

export const ITEMS_STATUS = [
    {
        name: 'Chưa in',
        value: 'unprinted',
    },
    {
        name: 'Đã đẩy',
        value: 'pushed',
    },
    {
        name: 'Đã in',
        value: 'printed',
    },
    {
        name: 'Đã cắt',
        value: 'cut',
    },
    {
        name: 'Đã khắc',
        value: 'engraved',
    },
    {
        name: 'Đã hoàn thiện',
        value: 'improved',
    },
    {
        name: 'Hoàn thành',
        value: 'completed',
    },
    {
        name: 'Lỗi',
        value: 'error',
    },
    {
        name: 'Đã sửa',
        value: 'repaired',
    },
    {
        name: 'Thất lạc',
        value: 'lost',
    },
    {
        name: 'Đã ship',
        value: 'shipped',
    },
    {
        name: 'QC sau ép',
        value: 'confirmed',
    },
    {
        name: 'Đang chờ',
        value: 'pending',
    },
    {
        name: 'Đang in',
        value: 'printing',
    },
    {
        name: 'Đang ép',
        value: 'transferring',
    },
    {
        name: 'Đã ép',
        value: 'transferred',
    },
    {
        name: 'Đang may',
        value: 'sewing',
    },
    {
        name: 'Đã chuyển',
        value: 'moved',
    },
    {
        name: 'Hủy ship',
        value: 'cancel-ship',
    },
    {
        name: 'Đã ship',
        value: 'manual-package',
    }
]

export const ORDERS_SORT = [
    {
        name: 'Số đơn: mới tới cũ',
        value: {marketplace: 'decs'},
    },
    {
        name: 'Ngày in: mới tới cũ',
        value: {mark_printed_at: 'decs'},
    },
]

export const TOTAL_ITEMS = [
    {
        name: 'Tất cả',
        value: '',
    },
    {
        name: '1',
        value: '1',
    },
    {
        name: '2',
        value: '2',
    },
    {
        name: '3',
        value: '3',
    },
    {
        name: '4',
        value: '4',
    },
    {
        name: '5',
        value: '5',
    },
    {
        name: '6',
        value: '6',
    },
    {
        name: '7',
        value: '7',
    },
    {
        name: '8',
        value: '8',
    },
    {
        name: '9',
        value: '9',
    },
    {
        name: '10',
        value: '10',
    },
]

export const COMMIT_BLOCK = [
    {
        name: 'All',
        value: '',
    },
    {
        name: '1 ngày',
        value: '1_day',
    },
    {
        name: '2 ngày',
        value: '2_days',
    },
    {
        name: '3 ngày',
        value: '3_days',
    },
    {
        name: 'Quá 3 ngày',
        value: 'over_3_days',
    },
]

export const AUTO_APPROVED = [
    {
        name: 'All',
        value: '',
    },
    {
        name: 'Yes',
        value: true,
    },
    {
        name: 'No',
        value: false,
    },
]

export const REQUEST_UPDATE_ORDER = [
    {name: 'Waiting update', value: 'waiting-update-design'},
    {name: 'Updated', value: 'updated'},
    {name: 'No request', value: 'no-request'}
]

export const TAGS = [
    {
        label: 'FBA',
        value: 'fba'
    },
    {
        label: 'Gift',
        value: 'gift'
    },
    {
        label: 'Sample',
        value: 'sample'
    },
    {
        label: 'Fastship',
        value: 'fastship'
    },
    {
        label: 'Priority Store',
        value: 'priority-store'
    },
    {
        label: 'UIDSAMPLE',
        value: 'UIDSAMPLE'
    },
    {
        label: 'Fastproduction',
        value: 'fastproduction'
    },
    {
        label: 'Cutoff',
        value: 'cutoff'
    },
    {
        label: 'CutOff noel',
        value: 'cutoff_noel'
    },
    {
        label: 'CutOff new year',
        value: 'cutoff_new_year'
    },
    {
        label: 'TikTok',
        value: 'tiktok'
    },
    {
        label: 'Combo_fac',
        value: 'combo_fac'
    },
    {
        label: 'rnd_test',
        value: 'rnd_test'
    },
]
